import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalasComponent } from './salas.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule } from '@po-ui/ng-templates';
import { SalasEditComponent } from './salas-edit/salas-edit.component';



@NgModule({
  declarations: [SalasComponent, SalasEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModule,
    PoPageDynamicEditModule
  ]
})
export class SalasModule { }

